import { useQuery } from "@tanstack/react-query";
import { getMerchantsFacilities } from "Infrastructure/Api/Api";
import { MS_TIME } from "Utils/TimeUtils";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import type { EntityListOfFacilityWithMerchantDto } from "Infrastructure/Api/Api";

const FACILITIES_QUERY_KEY = "FACILITIES";

export const facilitiesKeys = {
  all: [FACILITIES_QUERY_KEY] as const,
  filtered: (
    categoryCode?: string | null,
    municipality?: string | null,
    pageSize?: number,
    pageNumber?: number,
  ) =>
    [
      ...facilitiesKeys.all,
      categoryCode ?? null,
      municipality ?? null,
      pageSize ?? null,
      pageNumber ?? null,
    ] as const,
};

export const useFacilitiesQuery = (
  categoryCode?: string | null,
  municipality?: string | null,
  pageSize?: number,
  pageNumber?: number,
) =>
  useQuery<EntityListOfFacilityWithMerchantDto>({
    queryKey: facilitiesKeys.filtered(
      categoryCode,
      municipality,
      pageSize,
      pageNumber,
    ),
    queryFn: processResponseWithApiProblemDetails(() =>
      getMerchantsFacilities(categoryCode, municipality, pageSize, pageNumber),
    ),
    refetchOnWindowFocus: false,
    staleTime: 5 * MS_TIME.minute,
  });
